import script from "./MobileMainNavigationComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileMainNavigationComponent.vue?vue&type=script&setup=true&lang=js"

import "./MobileMainNavigationComponent.vue?vue&type=style&index=0&id=1671f2f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1671f2f9"]])

export default __exports__